import * as Yup from 'yup'

import { formValidationSchemaNoChanged } from '../../../Form'
import {
  REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_BY_AUDIENCE,
  REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_TITLE_KEY,
} from '../RequestProfileTabEmails.constants'

import {
  REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME,
  REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_OPTIONS,
} from './RequestProfileTabEmailsMoveToTabModal.constants'

function getAudienceLabel(audience, t) {
  const contactType =
    REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_BY_AUDIENCE[audience]

  return t(REQUEST_PROFILE_TAB_EMAILS_CONTACT_TYPE_TITLE_KEY[contactType])
}

export function getRequestProfileTabEmailsMoveToTabOptions({ t }) {
  return REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_OPTIONS.map(audience => ({
    label: getAudienceLabel(audience, t),
    value: audience,
  }))
}

export function getRequestProfileTabEmailsMoveToTabInitialValues({
  currentAudience,
  options,
}) {
  return {
    [REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME]:
      options.find(option => option.value === currentAudience) || null,
  }
}

export function getRequestProfileTabEmailsMoveToTabValidationSchema(
  initialValues
) {
  return Yup.object({
    [REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME]: Yup.object()
      .nullable()
      .required(true),
  }).concat(formValidationSchemaNoChanged({ initialValues }))
}
